import BaseRepository from './base.repository';

class HomeRepository extends BaseRepository {
  constructor() {
    super('/home');
  }

  getHome() {
    return this.client.get('');
  }

  getRelatedContents() {
    return this.client.get('/related-contents');
  }

  getSelfCareTips(params) {
    return this.client.get('/self-care-tips', params);
  }

  getSelfCareTip(mainUnique) {
    return this.client.get(`/self-care-tips/${mainUnique}`);
  }

  getDryWeightUpdate() {
    return this.client.get('/dry-weight-update');
  }

  closeDryWeightUpdate(itemUnique) {
    return this.client.post(`/dry-weight-update/${itemUnique}/close`);
  }

  getMicroEducationPrompt() {
    return this.client.get('/micro-education-prompt');
  }

  answerMicroEducationPrompt(mainUnique, payload) {
    return this.client.post(`/micro-education-prompt/${mainUnique}/answers`, payload);
  }

  getEmotionCheckinChoices() {
    return this.client.get('/emotion-checkins');
  }

  getEmotionHistory() {
    return this.client.get('/emotion-checkins/history');
  }

  getEmotionHistoryEntry(itemUnique) {
    return this.client.get(`/emotion-checkins/history/${itemUnique}`);
  }

  submitEmotionCheckin(payload) {
    return this.client.post('/emotion-checkins', payload);
  }
}

export default new HomeRepository();
